<div class="popover__wrapper">
  <a href="javascript:void(0)" class="logo auto-shining">
    <p class="popover__title"><img loading="lazy" data-src="/assets/images/Assured1.png"
        class="assure_image img-responsive" alt="ketto assured">
    </p>
  </a>
  <div class="popover__content">
    <h3 class="popover-title">{{'Stories.donations.sealTrustAuthenticity' | translatePipe | async}}</h3>
    <div class="inline">
      <i class="material-icons">check_circle</i>{{'Stories.donations.directToBeneficiary' | translatePipe | async}}
    </div>
    <div class="inline">
      <i class="material-icons">check_circle</i>{{'Stories.donations.donationProtection' | translatePipe | async}}
    </div>
    <div class="inline">
      <i class="material-icons">check_circle</i>{{'Stories.donations.donorProtection' | translatePipe | async}}
    </div>
    <div class="inline">
      <i class="material-icons">check_circle</i>{{'Stories.donations.encrypted' | translatePipe | async}}
    </div>

  </div>
</div>